import { ModelAttributes, ReadonlyModel, model, modelConfig } from "@mixitone/oom";

export type ResourceScanOutput = "count" | "ids" | "ids_and_fields";

export interface ResourceScanAttachedData {
  type: "resource_scan";
  resource: string;
  output: ResourceScanOutput;
  scannedCount: number;
  matchedCount: number;
  resultCount: number;
  ids?: string[];
  rows?: Array<Record<string, unknown>>;
  fields?: string[];
  truncatedIds?: boolean;
  truncatedRows?: boolean;
  warnings?: string[];
}

export interface ResourceBatchAnalysisAttachedData {
  type: "resource_batch_analysis";
  resource: string;
  question: string;
  scannedCount: number;
  filteredCount: number;
  analyzedCount: number;
  batchCount: number;
  failedBatchCount?: number;
  matchedCount: number;
  matchedIds?: string[];
  reasons?: Array<{ id: string; reason: string }>;
  summaries?: string[];
  truncatedIds?: boolean;
  truncatedReasons?: boolean;
  truncatedBatches?: boolean;
  warnings?: string[];
}

export type TaskAttachedDataPayload =
  ResourceScanAttachedData | ResourceBatchAnalysisAttachedData | Record<string, unknown>;

export interface Task {
  name: string; // Task title/description
  status: "pending" | "completed";
  completed_at?: string; // ISO timestamp when completed
  attached_data?: {
    tool_call_id?: string; // Reference to tool call that generated data
    message_ids?: string[]; // IDs of messages that were hidden when data attached
    data: TaskAttachedDataPayload;
    attached_at: string; // ISO timestamp
  };
  created_at: string; // ISO timestamp
}

export interface TaskList {
  tasks: Task[];
  completed_at?: string; // ISO timestamp when all tasks completed
  created_at: string; // ISO timestamp when task list created
}

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    account_user_id: {
      type: "string",
    },
    created_at: {
      type: "datetime",
    },
    is_deleted: {
      type: "boolean",
    },
    model: {
      type: "string",
    },
    task_list: {
      type: "json",
      jsonType: {} as TaskList,
    },
    updated_at: {
      type: "datetime",
    },
    user_id: {
      type: "string",
    },
  },
  {},
  {},
);

interface AgentChat extends ModelAttributes<typeof config> {}

@model("agent_chats", config)
class AgentChat extends ReadonlyModel<typeof config> {}

export default AgentChat;
